import React from 'react';
import { Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
    return (
        <div>
            <Typography variant="h1">404</Typography>
            <Typography variant="h4">Page Not Found</Typography>
            <Typography variant="body1">The page you are looking for does not exist.</Typography>
            {/* <Button component={Link} to="/" variant="contained" color="primary">
                Go Back Home
            </Button> */}
        </div>
    );
};

export default NotFound;